import React, { useEffect } from 'react';
import strings from '../../strings/strings.json'


interface Props {
  malware_data: any
  compressed_data: any
  normalCallback: (data: any) => void
  compressedCallback: (data: any, key: string) => void
  malwareFile: any
}

export default function MalwareFiles(props: Props) {

  const mapHandler = (data: any, index: number) => {
    return (
      <div
        key={index}
        className={`flex items-center border-b w-52 border-gray-200 py-4 hover:bg-gray-100 cursor-pointer ${props.malwareFile === data ? 'bg-gray-200' : ''}`}
        onClick={() => props.normalCallback(data)}
      >
        <img src={require('../../assets/icons/warning.svg').default} alt="Icon" />
        <div className='primary_text_color truncate VazirEng mr-1'><span dir='ltr' title={data}>{data}</span></div>
      </div>
    )
  }

  const compressedMapHandler = (data: any, index: number) => {
    return (
      <div key={index}>
        {
          Object.keys(data).map((dta: any, inx: number) => {
            return (
              <div key={inx}
                className={`flex items-center border-b border-gray-200 py-4 hover:bg-gray-100 cursor-pointer `}
                onClick={() => props.compressedCallback(data[dta], Object.keys(props.compressed_data)[index])}
              >
                <img src={require('../../assets/icons/warning.svg').default} alt="Icon" />
                <div className='w-52 flex flex-col VazirEng mr-1'>
                  <div className='truncate'><span>{'<=='}</span> <span dir='ltr' title={Object.keys(props.compressed_data)[index]}>{Object.keys(props.compressed_data)[index]}</span></div>
                  <div className='truncate secondry_text_color text-xs' title={`${dta}`}><span dir='ltr'>{dta}</span></div>
                </div>
              </div>
            )
          })
        }
      </div>
    )
  }

  return (
    (props.malware_data.length !== 0 || Object.values(props.compressed_data).length !== 0) ?
      <div className='border-r border-gray-200 pt-10 px-4 h-full'>
        <div className='primary_text_color font-bold text-lg'>{strings.public_infectedFiles}</div>
        <div className=''>
          {props.malware_data.map(mapHandler)}
          {props.compressed_data !== undefined && (Object.values(props.compressed_data)).map(compressedMapHandler)}
        </div>
      </div>
      :
      <div></div>
  )
}
